import React from 'react';
import Switch from '@material-ui/core/Switch';
import PropTypes from 'prop-types'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { cyan } from '@material-ui/core/colors';

const styles = {
  block: {
    maxWidth: 250,
  },
  toggle: {
    marginBottom: 16,
  },
  thumbOff: {
    backgroundColor: '#ffcccc',
  },
  trackOff: {
    backgroundColor: '#ff9d9d',
  },
  thumbSwitched: {
    backgroundColor: 'rgb(0, 150, 136)',
  },
  trackSwitched: {
    backgroundColor: 'rgb(171, 220, 215)',
  },
  labelStyle: {
    color: 'red',
  },
};

class ToggleItem extends React.Component {

	render(){
		return(
        <FormControlLabel
          label={this.props.name}
          labelStyle={{fontSize: '14px'}}
          control={
            <Switch
              color="primary"
              checked={this.props.active}
              onChange={this.props.handleClick}
              labelPosition="right"
              style={{padding:'5px 0'}}
              labelStyle={{fontWeight:400, fontSize: '14px'}} 
              thumbSwitchedStyle={styles.thumbSwitched}
              trackSwitchedStyle={styles.trackSwitched}
            />}
        />
    );
	}
}

ToggleItem.propTypes = {
  handleClick: PropTypes.func,
  name: PropTypes.string,
  active: PropTypes.bool
};

export {ToggleItem}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/togglegroup/toggleItem.js